import { StandardEvents } from '@shopify/events';
import { DrawerOpenEvent } from '@theme/theme-drawer';

class CartRelatedProducts extends HTMLElement {
  connectedCallback() {
    this.drawer = this.closest('theme-drawer');
    this.drawer?.addEventListener(DrawerOpenEvent.eventName, this.load);
    document.addEventListener(StandardEvents.cartLinesUpdate, this.refresh);
    if (this.drawer?.hasAttribute('open')) this.load();
  }

  disconnectedCallback() {
    this.drawer?.removeEventListener(DrawerOpenEvent.eventName, this.load);
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.refresh);
    this.controller?.abort();
  }

  refresh = () => {
    this.key = null;
    this.hidden = true;
    if (this.drawer?.hasAttribute('open')) this.load();
  };

  load = async () => {
    this.controller?.abort();
    const controller = new AbortController();
    this.controller = controller;
    const signal = controller.signal;
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, { signal });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      const key = cart.items.map((item) => item.product_id).join(',');
      if (!key) { this.hidden = true; return; }
      if (key === this.key) return;
      this.hidden = true;
      const url = new URL(this.dataset.url, window.location.origin);
      url.search = new URLSearchParams({ product_id: cart.items[0].product_id, section_id: 'cart-related-products', intent: 'related', limit: 10 });
      const result = await fetch(url, { signal });
      if (!result.ok) throw new Error('Recommendations unavailable');
      const html = new DOMParser().parseFromString(await result.text(), 'text/html');
      const content = html.querySelector('[data-cart-related-results]');
      const target = this.querySelector('[data-cart-related-items]');
      if (!content || !target) return;
      const excluded = new Set(cart.items.map((item) => String(item.product_id)));
      for (const card of content.querySelectorAll('product-card')) {
        if (excluded.has(card.dataset.productId)) card.closest('.cart-related__item')?.remove();
      }
      target.replaceChildren(...content.children);
      this.key = key;
      this.hidden = !target.children.length;
    } catch (error) {
      if (error.name !== 'AbortError') this.hidden = true;
    }
  };
}

if (!customElements.get('cart-related-products')) customElements.define('cart-related-products', CartRelatedProducts);
